var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-recaptcha", {
    ref: "recaptcha",
    staticClass: "d-inline-block captcha-component captcha-recaptcha",
    attrs: {
      sitekey: _vm.sitekey,
      loadRecaptchaScript: true,
      language: _vm.language,
    },
    on: { verify: _vm.onVerify, expired: _vm.onExpired, render: _vm.onRender },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }